export const insertComment = async ({ chargingPointUUID, payload }) => {
    try {

        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingPointUUID}/comment`

        const api = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify(payload),
        })

        const response = await api.json()
        return response.data
    } catch (error) {
        console.error('Could not create comment', error)
    }
}

export const getComments = async (chargingPointUUID) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingPointUUID}/comments`

        const api = await fetch(url, {
            method: 'GET',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not get comments')
    }

}

export const updateComment = async ({ commentUUID, payload }) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/comment/${commentUUID}`

        const api = await fetch(url, {
            method: 'PATCH',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify(payload),
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not update comment')
    }

}

export const deleteComment = async (commentUUID) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/comment/${commentUUID}`

        const api = await fetch(url, {
            method: 'DELETE',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not delete comment')
    }
}
